module.exports = __webpack_public_path__ + "static/media/bbqube_big.08c8e87c.svg";